<template>
	<tr>
		<td>
			<span :class="{ blocked }">{{ ip }}</span>
		</td>
		<td>
			<span>{{ started }}</span>
		</td>
		<td>
			<span>{{ submitted }}</span>
		</td>
		<td class="actions">
			<ToggleBlockAction
				:blocked="blocked"
				:updating="updating"
				@block="block"
				@unblock="unblock"
			/>
		</td>
	</tr>
</template>

<script>
import ToggleBlockAction from '@/components/admin/ToggleBlockAction'

export default {
	name: 'IPAddressesTableRow',
	props: {
		ip: String,
		started: Number,
		submitted: Number,
		blocked: Boolean,
		updating: Boolean
	},
	methods: {
		block() {
			this.$emit('block', { ip: this.ip })
		},
		unblock() {
			this.$emit('unblock', { ip: this.ip })
		}
	},
	components: {
		ToggleBlockAction
	}
}
</script>

<style lang="scss" scoped>
span.blocked {
	opacity: 0.5;
	text-decoration: line-through;
}
</style>
